import { AtButton, AtButtonProps, AtIconInformative, AtIconInformativeProps } from '../../atoms'
import { MlImages } from '../../molecules'
import { AtButtonDimensions, AtButtonTypes } from '../../types'
import { cn } from '../../utils'
import { Media, OrMedia } from '../or-media'

export interface OrContentBlockEProps {
  title: string
  subTitle?: string
  informative?: AtIconInformativeProps[]
  media?: Media[]
  button?: Pick<AtButtonProps, 'openUrl' | 'target'>
  buttonText?: string
  onClick?: () => void
  onTrackClick?: () => void
  fullWidth?: boolean
}

export const OrContentBlockE = ({
  title,
  subTitle,
  informative,
  media,
  button,
  buttonText,
  onClick,
  onTrackClick,
  fullWidth,
}: OrContentBlockEProps) => {
  return (
    <section className="lg:max-w-screen-lg mx-auto">
      <div className="slg:flex slg:gap-7.5 slg:flex-row-reverse">
        <div className="slg:flex-1 slg:mt-12 sm:px-8 px-4 slg:pl-0 slg:pr-12 lg:pr-0">
          <div className={cn('slg:pl-5 lg:pl-0', fullWidth && 'lg:pr-[10.438rem]')}>
            <div className="flex flex-col">
              <div className="mb-4">
                <h2 className="text-neutrals-900 text-32 font-heading">{title}</h2>
              </div>
              <div className="mb-9">
                <p className="text-neutrals-700 text-16">{subTitle}</p>
              </div>
            </div>
            <div className="flex flex-row flex-wrap">
              {informative?.map((content, index) => (
                <div className="mb-4 slg:mb-10 w-full px-1" key={index}>
                  <AtIconInformative
                    className="items-start"
                    {...content}
                    classIcon="w-10 h-10 shrink-0 slg:mr-6 mr-2"
                    titleClass="font-heading slg:text-24 text-20 font-medium"
                    labelClass="slg:text-16"
                    contentClass="pt-0"
                  />
                </div>
              ))}
            </div>
            {button ? (
              <div>
                <AtButton
                  title={buttonText}
                  type={AtButtonTypes.PRIMARY}
                  size={AtButtonDimensions.LARGE}
                  className="w-full mt-4 mb-16 slg:mb-0"
                  align="center"
                  openUrl={button?.openUrl}
                  target={button?.target}
                  onClick={button?.openUrl ? onClick : undefined}
                  parentName="ContentBlockE"
                  onTrackClick={onTrackClick}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="slg:flex-1 ">
          <div className="flex flex-row justify-end slg:justify-start mt-7">
            <div className="relative w-full">
              <div className="slg:hidden">
                <div className="w-full pl-16 sm:pl-32 flex items-end	justify-end px-8">
                  {/* TODO: Change the name of the component to something more universal like OrSwiper and refactor */}
                  {media && (
                    <MlImages
                      aspectRatio="3:4"
                      media={media.map((item) => ({ ...item, className: 'mb-8 sm:mb-12 sm:mr-6' }))}
                    />
                  )}
                  <div className="w-full h-[12rem] absolute bg-neutrals-100 right-4 sm:right-8 bottom-0 -z-10"></div>
                </div>
              </div>
              <div className="hidden slg:block">
                {/*
                  // VQA REF: studio-content-block-e-ml-images
                  // TODO: remove when QA has completed their pass
                */}
                <div className="slg:w-full slg:pr-16 slg:pl-[3.813rem] slg:flex slg:items-end slg:justify-end lg:pl-[10.438rem]">
                  {/* TODO: Change the name of the component to something more universal like OrSwiper and refactor */}
                  {media && (
                    <MlImages
                      aspectRatio="5:6"
                      media={media.map((item) => ({ ...item, className: 'mb-8 sm:mb-12 sm:mr-6' }))}
                    />
                  )}
                </div>
              </div>
              <div className="hidden slg:block w-full h-[12rem] absolute bg-neutrals-100 top-[60%] right-32 -z-10 slg:h-80"></div>
              {/* <div className="pl-4 lg:pl-0"></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
